export { useIsAgeVerificationHidden } from "./useIsAgeVerificationHidden";
